import { render } from "./AdminTopBar.vue?vue&type=template&id=05b04cf4&scoped=true"
import script from "./AdminTopBar.vue?vue&type=script&lang=js"
export * from "./AdminTopBar.vue?vue&type=script&lang=js"

import "./AdminTopBar.vue?vue&type=style&index=0&id=05b04cf4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b04cf4"]])

export default __exports__